import React from 'react';
import Basics from './Basic'
import Forms from './Forms'
import Components from './Components'
import Icons from './Icons'
import Notifications from './Notifications'
import Tables from './PrimeTable'
import Drawers from './Drawers';
import './StyleGuide.scss';
import StyleGuideNav from './StyleGuideNav';
import Charts from './Charts';
import DocumentTitle from 'react-document-title'
import Heatmap from './Heatmap';

export default class StyleGuidePage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activePageName: null
        };
    }

    changePage = (event) => {
        this.setState({ activePageName: event.target.innerHTML.replace(/ /g, '') });
    }

    renderIdentifier = () => {

        switch (this.state.activePageName) {
            case "Basics":
                return <Basics />
            case "Charts":
                return <Charts />
            case "Components":
                return <Components/>
            case "Drawers":
                return <Drawers />
            case "Forms":
                return <Forms/>
            case "Icons":
                return <Icons/>
            case "Notifications":
                return <Notifications />
            case "Tables":
                return <Tables/>
            case "Heatmap":
                return <Heatmap />
            default:
                return <div className="mx-auto" style={{ "width": "80%" }}>
                    <div className="jumbotron mt-2">
                        <h1 className="display-4">Welcome!</h1>
                        <p className="lead">This is a new style guide for V5.</p>
                        <hr className="my-2" />
                        <p>This part of the application is meant to help you hit the ground running with examples on how to use the different components we use and also to use as a reference for different UI standards that have been decided upon by the team.</p>
                    </div>
                </div>;
        }

    }

    render() {

        const isListActive = (this.state.activePageName) ? '' : ' active';
        const isContainerActive = (!this.state.activePageName) ? '' : ' active';


        return (

            <div className="row no-gutters mt-2">
                <DocumentTitle title="Style Guide" />
                <div className={'identifier-list' + isListActive}>
                    <StyleGuideNav onClick={this.changePage} activeItemName={this.state.activePageName} />
                </div>
                <div className={'identifier-container' + isContainerActive}>
                    {this.renderIdentifier()}
                </div>
            </div>


        );
    }
}
